module.exports = "<div class=\"budget-tree-mobile-container\">\r\n  <div class=\"cards-container\"></div>\r\n</div>\r\n";